import { render, staticRenderFns } from "./transfer_unit.vue?vue&type=template&id=f96e79a2"
import script from "./transfer_unit.vue?vue&type=script&lang=js"
export * from "./transfer_unit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports